export default "__VITE_ASSET__BYbIJ2yL__"